export const RplStatusConstants = {
    APPROVED: '83d0900a-6c2c-4d4f-926d-00cd226e9888',
    THREE_D_REDIRECT: 'b1ca986e-c5e3-4a32-a66d-0cfdd23357e7',
    PENDING_UPDATED: '0592a2c1-cb57-48a1-a8e9-5ae03efbcf7e',
    PAYMENT_RECEIVED: '91159afb-6a22-4386-a156-6a1d6c1ebd74',
    SHIPPED: 'd8f70bb2-4d53-4531-babd-8d52d1771b9c',
    TO_COURIER: '491133ab-ca2f-4e29-8eec-907a36ca37f1',
    DECLINED: '6cb6efd2-a208-4456-b209-a89ad7d49318',
    DECLINED_WITH_FEEDBACK: 'e6c6eec4-6b83-4ce4-98c0-aac85f8aab96',
    PENDING: 'd369b17f-5fff-4dd0-9262-c14a94ff6ec6',
    BEING_SIGNED: 'c3e54c4c-1322-485b-bc7d-d7459a715fb9',
    SELF_COLLECT: '3ae269c9-a6ea-49d5-b4fe-dc4a30f7debe',
    REVIEWED_WITH_FEEDBACK: 'ae2c2454-9da0-4238-8ba7-dc5a52996c55',
    FORFEITED: 'a3f1c2d4-8e5b-4a7f-9d6e-2b1c0e4f8a3d'
}